import React, { useState } from 'react';
import { ServerInterface } from "src/store/mine_craft/serversSlice";

import { InboxOutlined } from '@ant-design/icons';
import Card from "src/componets/Card";
import PlayersChart from "./_PlayersChart";
import SessionsHistory from "./_SessionsHistory";
import StatusHistory from "./_StatusHistory";
import PlayerProfile from "./_PlayerProfile";

// Read-only analytics for a hosted server: who played when (sessions),
// how busy it was (activity chart) and whether it stayed up (uptime,
// crashes, live ping). Each card loads and refreshes on its own.
const _Activity = ({ server }: { server: ServerInterface | undefined }) => {
  const [profileTag, setProfileTag] = useState<string | null>(null);

  if (!server || !server.hosted_server) {
    return (
      <Card>
        <div className='v-srv-empty'>
          <InboxOutlined className='o-icon' />
          <div className='o-title'>Not hosted through crafty-servers</div>
          <div className='o-hint'>Player activity is only tracked for servers we host.</div>
        </div>
      </Card>
    );
  }

  return (
    <>
      <PlayersChart server={server} />

      <div className='v-srv-activity'>
        <SessionsHistory server={server} onSelectPlayer={setProfileTag} />
        <StatusHistory server={server} />
      </div>

      <PlayerProfile server={server} gamertag={profileTag} onClose={() => setProfileTag(null)} />
    </>
  );
}

export default _Activity;
